import type { Outcome } from '../../coupon/entry.js';

export const OUTCOME_MAP_1X2 = new Map<string, Outcome>([
  ['1', 0 as Outcome],
  ['X', 1 as Outcome],
  ['2', 2 as Outcome],
]);
